<template>
  <div class="app_download template">
    <div class="layout onlypc">
      <div class="box">
        <div class="left">{{ langTxt[lang].index.appDownload[0] }}</div>
        <div class="right">
          <a :href="appDownloadUr">
            <div class="btn xbd" @click="reportRefereeUser">
              <svg
                width="140"
                height="32"
                viewBox="0 0 140 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M43.35 12.004H45.086L48.936 22H47.298L46.36 19.424H42.062L41.124 22H39.5L43.35 12.004ZM42.524 18.164H45.898L44.246 13.642H44.19L42.524 18.164ZM53.4416 14.566C55.2429 14.566 56.1436 15.5553 56.1436 17.534V22H54.6596V17.66C54.6596 16.428 54.0949 15.812 52.9656 15.812C52.5269 15.812 52.1583 15.9613 51.8596 16.26C51.5143 16.6053 51.3136 17.0673 51.2576 17.646V22H49.7736V14.762H51.2576V15.658C51.5283 15.3033 51.8503 15.0327 52.2236 14.846C52.5689 14.6593 52.9749 14.566 53.4416 14.566ZM63.048 11.808H64.532V22H63.146V21.132C62.6327 21.8413 61.886 22.196 60.906 22.196C59.842 22.196 59.0067 21.818 58.4 21.062C57.84 20.362 57.56 19.4567 57.56 18.346C57.56 17.2727 57.8353 16.3907 58.386 15.7C58.974 14.944 59.7907 14.566 60.836 14.566C61.7227 14.566 62.46 14.9907 63.048 15.84V11.808ZM61.172 15.77C60.4347 15.77 59.8933 16.0173 59.548 16.512C59.24 16.932 59.086 17.5433 59.086 18.346C59.086 19.1487 59.2307 19.7693 59.52 20.208C59.856 20.7307 60.3927 20.992 61.13 20.992C61.7553 20.992 62.2547 20.7353 62.628 20.222C62.936 19.7553 63.09 19.1627 63.09 18.444V18.318C63.09 17.5433 62.9033 16.9133 62.53 16.428C62.1753 15.9893 61.7227 15.77 61.172 15.77ZM69.5672 14.566C69.9499 14.566 70.2625 14.6267 70.5052 14.748V16.232C70.1692 16.1293 69.8192 16.078 69.4552 16.078C69.0072 16.078 68.6059 16.26 68.2512 16.624C67.8779 17.0067 67.6912 17.52 67.6912 18.164V22H66.2072V14.762H67.6912V15.854C67.8685 15.4713 68.1019 15.1773 68.3912 14.972C68.7179 14.7013 69.1099 14.566 69.5672 14.566ZM74.7482 14.566C75.8495 14.566 76.7268 14.93 77.3802 15.658C78.0335 16.386 78.3602 17.296 78.3602 18.388C78.3602 19.4893 78.0382 20.39 77.3942 21.09C76.7128 21.8273 75.8308 22.196 74.7482 22.196C73.6655 22.196 72.7835 21.8273 72.1022 21.09C71.4582 20.39 71.1362 19.4893 71.1362 18.388C71.1362 17.2773 71.4628 16.3673 72.1162 15.658C72.7788 14.93 73.6562 14.566 74.7482 14.566ZM74.7482 15.784C74.0575 15.784 73.5255 16.0547 73.1522 16.596C72.8255 17.044 72.6622 17.6413 72.6622 18.388C72.6622 19.1253 72.8255 19.718 73.1522 20.166C73.5348 20.7073 74.0668 20.978 74.7482 20.978C75.4202 20.978 75.9568 20.7073 76.3582 20.166C76.6942 19.69 76.8622 19.0973 76.8622 18.388C76.8622 17.6507 76.6942 17.0533 76.3582 16.596C75.9662 16.0547 75.4295 15.784 74.7482 15.784ZM80.8197 11.864C81.1277 11.864 81.375 11.9573 81.5617 12.144C81.7577 12.3213 81.8557 12.5593 81.8557 12.858C81.8557 13.138 81.753 13.3807 81.5477 13.586C81.3424 13.7727 81.0997 13.866 80.8197 13.866C80.5397 13.866 80.297 13.7727 80.0917 13.586C79.8957 13.39 79.7977 13.1473 79.7977 12.858C79.7977 12.5593 79.8957 12.3213 80.0917 12.144C80.2784 11.9573 80.521 11.864 80.8197 11.864ZM80.0777 14.762H81.5617V22H80.0777V14.762ZM88.7785 11.808H90.2625V22H88.8765V21.132C88.3631 21.8413 87.6165 22.196 86.6365 22.196C85.5725 22.196 84.7371 21.818 84.1305 21.062C83.5705 20.362 83.2905 19.4567 83.2905 18.346C83.2905 17.2727 83.5658 16.3907 84.1165 15.7C84.7045 14.944 85.5211 14.566 86.5665 14.566C87.4531 14.566 88.1905 14.9907 88.7785 15.84V11.808ZM86.9025 15.77C86.1651 15.77 85.6238 16.0173 85.2785 16.512C84.9705 16.932 84.8165 17.5433 84.8165 18.346C84.8165 19.1487 84.9611 19.7693 85.2505 20.208C85.5865 20.7307 86.1231 20.992 86.8605 20.992C87.4858 20.992 87.9851 20.7353 88.3585 20.222C88.6665 19.7553 88.8205 19.1627 88.8205 18.444V18.318C88.8205 17.5433 88.6338 16.9133 88.2605 16.428C87.9058 15.9893 87.4531 15.77 86.9025 15.77ZM99.6098 12.004H101.346L105.196 22H103.558L102.62 19.424H98.3218L97.3838 22H95.7598L99.6098 12.004ZM98.7838 18.164H102.158L100.506 13.642H100.45L98.7838 18.164ZM106.173 12.004H110.317C112.697 12.004 113.887 13.0167 113.887 15.042C113.887 17.086 112.688 18.108 110.289 18.108H107.699V22H106.173V12.004ZM107.699 13.306V16.806H110.191C110.947 16.806 111.498 16.666 111.843 16.386C112.189 16.0967 112.361 15.6487 112.361 15.042C112.361 14.4167 112.184 13.978 111.829 13.726C111.484 13.446 110.938 13.306 110.191 13.306H107.699ZM121.662 12.004H123.594L119.17 16.302L124.238 22H122.194L118.134 17.296L116.832 18.542V22H115.306V12.004H116.832V16.834L121.662 12.004Z"
                  fill="white"
                />
                <path
                  d="M15.5 22H35.5C35.5 18.6249 34.12 15.5947 31.36 13.6219L33.5466 11.4403C33.9111 11.0251 33.9111 10.6357 33.5466 10.2725C33.1821 9.90917 32.7917 9.90917 32.3749 10.2725L29.875 12.7646C28.5205 12.038 27.0622 11.6746 25.4999 11.6746C23.8854 11.6746 22.401 12.038 21.0466 12.7646L18.5466 10.2725C18.1821 9.90917 17.7916 9.90917 17.3751 10.2725C16.9583 10.6357 16.9583 11.0251 17.3751 11.4403L19.5632 13.6219C16.8544 15.5425 15.5 18.5729 15.5 22ZM30.0175 16.386C30.6756 16.386 31.2091 16.9179 31.2091 17.5739C31.2091 18.23 30.6756 18.7618 30.0175 18.7618C29.3594 18.7618 28.8259 18.23 28.8259 17.5739C28.8259 16.9179 29.3594 16.386 30.0175 16.386ZM20.9697 16.386C21.6278 16.386 22.1613 16.9179 22.1613 17.5739C22.1613 18.23 21.6278 18.7618 20.9697 18.7618C20.3116 18.7618 19.7781 18.23 19.7781 17.5739C19.7781 16.9179 20.3116 16.386 20.9697 16.386Z"
                  fill="white"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="139"
                  height="31"
                  rx="1.5"
                  stroke="white"
                  stroke-opacity="0.5"
                />
              </svg>
            </div>
          </a>
          <a :href="iosAppLoadUrl" target="_blank">
            <div class="btn xbd" @click="reportRefereeUser">
              <svg
                width="140"
                height="32"
                viewBox="0 0 140 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M49.85 11.004H51.586L55.436 21H53.798L52.86 18.424H48.562L47.624 21H46L49.85 11.004ZM49.024 17.164H52.398L50.746 12.642H50.69L49.024 17.164ZM59.8996 13.566C60.9543 13.566 61.7896 13.944 62.4056 14.7C62.9656 15.4 63.2456 16.3053 63.2456 17.416C63.2456 18.4707 62.9703 19.3527 62.4196 20.062C61.8316 20.818 61.0149 21.196 59.9696 21.196C59.0829 21.196 58.3456 20.776 57.7576 19.936V23.772H56.2736V13.762H57.6596V14.63C58.1636 13.9207 58.9103 13.566 59.8996 13.566ZM59.6756 14.77C59.0223 14.77 58.5229 15.0267 58.1776 15.54C57.8696 15.988 57.7156 16.5853 57.7156 17.332V17.458C57.7156 18.242 57.9069 18.8673 58.2896 19.334C58.6256 19.7727 59.0736 19.992 59.6336 19.992C60.3616 19.992 60.8983 19.754 61.2436 19.278C61.5609 18.8207 61.7196 18.2 61.7196 17.416C61.7196 16.6413 61.5749 16.0207 61.2856 15.554C60.9403 15.0313 60.4036 14.77 59.6756 14.77ZM68.2668 13.566C69.3214 13.566 70.1568 13.944 70.7728 14.7C71.3328 15.4 71.6128 16.3053 71.6128 17.416C71.6128 18.4707 71.3374 19.3527 70.7868 20.062C70.1988 20.818 69.3821 21.196 68.3368 21.196C67.4501 21.196 66.7128 20.776 66.1248 19.936V23.772H64.6408V13.762H66.0268V14.63C66.5308 13.9207 67.2774 13.566 68.2668 13.566ZM68.0428 14.77C67.3894 14.77 66.8901 15.0267 66.5448 15.54C66.2368 15.988 66.0828 16.5853 66.0828 17.332V17.458C66.0828 18.242 66.2741 18.8673 66.6568 19.334C66.9928 19.7727 67.4408 19.992 68.0008 19.992C68.7288 19.992 69.2654 19.754 69.6108 19.278C69.9281 18.8207 70.0868 18.2 70.0868 17.416C70.0868 16.6413 69.9421 16.0207 69.6528 15.554C69.3074 15.0313 68.7708 14.77 68.0428 14.77ZM81.3101 10.808C82.4861 10.808 83.3961 11.0553 84.0401 11.55C84.7401 12.0633 85.1367 12.866 85.2301 13.958H83.7181C83.5781 13.2953 83.3167 12.8287 82.9341 12.558C82.5514 12.2687 81.9821 12.124 81.2261 12.124C80.5727 12.124 80.0687 12.222 79.7141 12.418C79.2847 12.642 79.0701 13.006 79.0701 13.51C79.0701 13.958 79.3174 14.3127 79.8121 14.574C80.0547 14.714 80.6334 14.9193 81.5481 15.19C82.9294 15.6193 83.8021 15.946 84.1661 16.17C85.0247 16.6927 85.4541 17.4113 85.4541 18.326C85.4541 19.2127 85.1041 19.9173 84.4041 20.44C83.7041 20.944 82.7241 21.196 81.4641 21.196C80.2601 21.196 79.3081 20.9533 78.6081 20.468C77.7867 19.88 77.3341 18.956 77.2501 17.696H78.7621C78.8741 18.4893 79.1541 19.054 79.6021 19.39C80.0127 19.698 80.6334 19.852 81.4641 19.852C82.2014 19.852 82.8034 19.7213 83.2701 19.46C83.7181 19.208 83.9421 18.858 83.9421 18.41C83.9421 17.8593 83.6247 17.4207 82.9901 17.094C82.7567 16.982 82.0941 16.758 81.0021 16.422C79.7514 16.0207 78.9861 15.7453 78.7061 15.596C77.9407 15.1387 77.5581 14.4713 77.5581 13.594C77.5581 12.7167 77.9267 12.026 78.6641 11.522C79.3641 11.046 80.2461 10.808 81.3101 10.808ZM88.9325 11.424V13.762H90.5845V14.994H88.9325V19.194C88.9325 19.3807 88.9745 19.5253 89.0585 19.628C89.1519 19.7213 89.2825 19.768 89.4505 19.768H90.4025V21H89.2125C88.5872 21 88.1345 20.8367 87.8545 20.51C87.5839 20.2113 87.4485 19.7727 87.4485 19.194V14.994H86.1045V13.762H87.4485V12.04L88.9325 11.424ZM95.1115 13.566C96.2128 13.566 97.0901 13.93 97.7435 14.658C98.3968 15.386 98.7235 16.296 98.7235 17.388C98.7235 18.4893 98.4015 19.39 97.7575 20.09C97.0761 20.8273 96.1941 21.196 95.1115 21.196C94.0288 21.196 93.1468 20.8273 92.4655 20.09C91.8215 19.39 91.4995 18.4893 91.4995 17.388C91.4995 16.2773 91.8261 15.3673 92.4795 14.658C93.1421 13.93 94.0195 13.566 95.1115 13.566ZM95.1115 14.784C94.4208 14.784 93.8888 15.0547 93.5155 15.596C93.1888 16.044 93.0255 16.6413 93.0255 17.388C93.0255 18.1253 93.1888 18.718 93.5155 19.166C93.8981 19.7073 94.4301 19.978 95.1115 19.978C95.7835 19.978 96.3201 19.7073 96.7215 19.166C97.0575 18.69 97.2255 18.0973 97.2255 17.388C97.2255 16.6507 97.0575 16.0533 96.7215 15.596C96.3295 15.0547 95.7928 14.784 95.1115 14.784ZM103.493 13.566C103.876 13.566 104.188 13.6267 104.431 13.748V15.232C104.095 15.1293 103.745 15.078 103.381 15.078C102.933 15.078 102.532 15.26 102.177 15.624C101.804 16.0067 101.617 16.52 101.617 17.164V21H100.133V13.762H101.617V14.854C101.794 14.4713 102.028 14.1773 102.317 13.972C102.644 13.7013 103.036 13.566 103.493 13.566ZM108.408 13.566C109.603 13.566 110.503 13.9673 111.11 14.77C111.679 15.5073 111.969 16.5153 111.978 17.794H106.49C106.546 18.5127 106.737 19.054 107.064 19.418C107.409 19.7913 107.871 19.978 108.45 19.978C108.963 19.978 109.383 19.8567 109.71 19.614C109.943 19.4367 110.163 19.124 110.368 18.676H111.852C111.675 19.3667 111.343 19.9313 110.858 20.37C110.223 20.9207 109.425 21.196 108.464 21.196C107.391 21.196 106.546 20.8647 105.93 20.202C105.258 19.502 104.922 18.5593 104.922 17.374C104.922 16.2913 105.239 15.3907 105.874 14.672C106.49 13.9347 107.335 13.566 108.408 13.566ZM108.45 14.784C107.89 14.784 107.447 14.9473 107.12 15.274C106.803 15.61 106.602 16.0767 106.518 16.674H110.424C110.284 15.414 109.626 14.784 108.45 14.784Z"
                  fill="white"
                />
                <path
                  d="M39.5064 15.5983C39.5064 17.173 40.5332 18.5978 42 19.1977C41.7066 20.0975 41.2666 20.9974 40.7532 21.7472C40.0198 22.872 39.213 23.9219 37.9662 23.9219C36.7193 23.9968 36.2793 23.247 34.8858 23.247C33.4923 23.247 33.0522 23.9219 31.8787 23.9968C30.7053 24.0718 29.7518 22.7971 28.945 21.7472C27.3315 19.4976 26.158 15.4483 27.7716 12.6738C28.5783 11.3241 30.0452 10.4242 31.5854 10.4242C32.7588 10.4242 33.9323 11.1741 34.5924 11.1741C35.2525 11.1741 36.7193 10.1993 38.1862 10.3492C39.5064 10.4242 40.7532 11.0241 41.5599 12.1489C40.3131 12.8238 39.5797 14.1736 39.5064 15.5983V15.5983ZM34.5191 10.1243C34.4457 9.07446 34.8124 8.09963 35.4725 7.34976C36.2059 6.59989 37.1594 6.07499 38.1862 6C38.2595 7.04982 37.8928 8.09963 37.2327 8.8495C36.5727 9.74934 35.5459 10.1993 34.5191 10.1243Z"
                  fill="white"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="139"
                  height="31"
                  rx="1.5"
                  stroke="white"
                  stroke-opacity="0.5"
                />
              </svg>
            </div>
          </a>
        </div>
        <!-- <div class="arrow" @click="arrowDown"><svg width="24" height="28" viewBox="0 0 24 28" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11.9583 8.54167L3.41667 0L0.5 3.125L11.9583 14.5833L23.4167 3.125L20.5 0L11.9583 8.54167ZM11.9583 21.25L3.41667 12.7083L0.5 15.625L11.9583 27.0833L23.4167 15.625L20.5 12.7083L11.9583 21.25Z"
                            fill="white" fill-opacity="0.1" />
                    </svg>
                </div> -->
      </div>
    </div>
    <div class="layout onlymobile">
      <div class="box">
        <div class="right">
          <a :href="appDownloadUr">
            <ui_btn_3 @click="reportRefereeUser" class="xbd">
              <span class="android"
                ><svg
                  width="94"
                  height="15"
                  viewBox="0 0 94 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M32.95 1.148H35.182L40.132 14H38.026L36.82 10.688H31.294L30.088 14H28L32.95 1.148ZM31.888 9.068H36.226L34.102 3.254H34.03L31.888 9.068ZM45.9249 4.442C48.2409 4.442 49.3989 5.714 49.3989 8.258V14H47.4909V8.42C47.4909 6.836 46.7649 6.044 45.3129 6.044C44.7489 6.044 44.2749 6.236 43.8909 6.62C43.4469 7.064 43.1889 7.658 43.1169 8.402V14H41.2089V4.694H43.1169V5.846C43.4649 5.39 43.8789 5.042 44.3589 4.802C44.8029 4.562 45.3249 4.442 45.9249 4.442ZM58.276 0.895999H60.184V14H58.402V12.884C57.742 13.796 56.782 14.252 55.522 14.252C54.154 14.252 53.08 13.766 52.3 12.794C51.58 11.894 51.22 10.73 51.22 9.302C51.22 7.922 51.574 6.788 52.282 5.9C53.038 4.928 54.088 4.442 55.432 4.442C56.572 4.442 57.52 4.988 58.276 6.08V0.895999ZM55.864 5.99C54.916 5.99 54.22 6.308 53.776 6.944C53.38 7.484 53.182 8.27 53.182 9.302C53.182 10.334 53.368 11.132 53.74 11.696C54.172 12.368 54.862 12.704 55.81 12.704C56.614 12.704 57.256 12.374 57.736 11.714C58.132 11.114 58.33 10.352 58.33 9.428V9.266C58.33 8.27 58.09 7.46 57.61 6.836C57.154 6.272 56.572 5.99 55.864 5.99ZM66.6578 4.442C67.1498 4.442 67.5518 4.52 67.8638 4.676V6.584C67.4318 6.452 66.9818 6.386 66.5138 6.386C65.9378 6.386 65.4218 6.62 64.9658 7.088C64.4858 7.58 64.2458 8.24 64.2458 9.068V14H62.3378V4.694H64.2458V6.098C64.4738 5.606 64.7738 5.228 65.1458 4.964C65.5658 4.616 66.0698 4.442 66.6578 4.442ZM73.3191 4.442C74.7351 4.442 75.8631 4.91 76.7031 5.846C77.5431 6.782 77.9631 7.952 77.9631 9.356C77.9631 10.772 77.5491 11.93 76.7211 12.83C75.8451 13.778 74.7111 14.252 73.3191 14.252C71.9271 14.252 70.7931 13.778 69.9171 12.83C69.0891 11.93 68.6751 10.772 68.6751 9.356C68.6751 7.928 69.0951 6.758 69.9351 5.846C70.7871 4.91 71.9151 4.442 73.3191 4.442ZM73.3191 6.008C72.4311 6.008 71.7471 6.356 71.2671 7.052C70.8471 7.628 70.6371 8.396 70.6371 9.356C70.6371 10.304 70.8471 11.066 71.2671 11.642C71.7591 12.338 72.4431 12.686 73.3191 12.686C74.1831 12.686 74.8731 12.338 75.3891 11.642C75.8211 11.03 76.0371 10.268 76.0371 9.356C76.0371 8.408 75.8211 7.64 75.3891 7.052C74.8851 6.356 74.1951 6.008 73.3191 6.008ZM81.1253 0.967999C81.5213 0.967999 81.8393 1.088 82.0793 1.328C82.3313 1.556 82.4573 1.862 82.4573 2.246C82.4573 2.606 82.3253 2.918 82.0613 3.182C81.7973 3.422 81.4853 3.542 81.1253 3.542C80.7653 3.542 80.4533 3.422 80.1893 3.182C79.9373 2.93 79.8113 2.618 79.8113 2.246C79.8113 1.862 79.9373 1.556 80.1893 1.328C80.4293 1.088 80.7413 0.967999 81.1253 0.967999ZM80.1713 4.694H82.0793V14H80.1713V4.694ZM91.358 0.895999H93.266V14H91.484V12.884C90.824 13.796 89.864 14.252 88.604 14.252C87.236 14.252 86.162 13.766 85.382 12.794C84.662 11.894 84.302 10.73 84.302 9.302C84.302 7.922 84.656 6.788 85.364 5.9C86.12 4.928 87.17 4.442 88.514 4.442C89.654 4.442 90.602 4.988 91.358 6.08V0.895999ZM88.946 5.99C87.998 5.99 87.302 6.308 86.858 6.944C86.462 7.484 86.264 8.27 86.264 9.302C86.264 10.334 86.45 11.132 86.822 11.696C87.254 12.368 87.944 12.704 88.892 12.704C89.696 12.704 90.338 12.374 90.818 11.714C91.214 11.114 91.412 10.352 91.412 9.428V9.266C91.412 8.27 91.172 7.46 90.692 6.836C90.236 6.272 89.654 5.99 88.946 5.99Z"
                    fill="white"
                  />
                  <path
                    d="M0 14H20C20 10.6249 18.62 7.59466 15.86 5.62191L18.0466 3.44032C18.4111 3.02506 18.4111 2.63565 18.0466 2.2725C17.6821 1.90917 17.2917 1.90917 16.8749 2.2725L14.375 4.76464C13.0205 4.03797 11.5622 3.67463 9.99988 3.67463C8.38543 3.67463 6.90099 4.03797 5.54656 4.76464L3.04661 2.2725C2.68214 1.90917 2.29165 1.90917 1.87508 2.2725C1.45831 2.63565 1.45831 3.02506 1.87508 3.44032L4.06325 5.62191C1.35438 7.54252 0 10.5729 0 14ZM14.5175 8.38605C15.1756 8.38605 15.7091 8.91788 15.7091 9.57395C15.7091 10.23 15.1756 10.7618 14.5175 10.7618C13.8594 10.7618 13.3259 10.23 13.3259 9.57395C13.3259 8.91788 13.8594 8.38605 14.5175 8.38605ZM5.46969 8.38605C6.12781 8.38605 6.66131 8.91788 6.66131 9.57395C6.66131 10.23 6.12781 10.7618 5.46969 10.7618C4.81158 10.7618 4.27807 10.23 4.27807 9.57395C4.27807 8.91788 4.81158 8.38605 5.46969 8.38605Z"
                    fill="white"
                  /></svg
              ></span>
            </ui_btn_3>
          </a>
          <a :href="iosAppLoadUrl" target="_blank">
            <ui_btn_3 :white="'white'" class="xbd" @click="reportRefereeUser">
              <span class="ios"
                ><svg
                  width="55"
                  height="18"
                  viewBox="0 0 55 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M26.296 4.148H28.24V17H26.296V4.148ZM36.4832 3.896C38.4392 3.896 39.9812 4.532 41.1092 5.804C42.1892 7.004 42.7292 8.6 42.7292 10.592C42.7292 12.548 42.1892 14.138 41.1092 15.362C39.9812 16.622 38.4392 17.252 36.4832 17.252C34.5272 17.252 32.9852 16.616 31.8572 15.344C30.7892 14.132 30.2552 12.548 30.2552 10.592C30.2552 8.624 30.7892 7.034 31.8572 5.822C32.9612 4.538 34.5032 3.896 36.4832 3.896ZM36.4832 5.624C35.1032 5.624 34.0412 6.086 33.2972 7.01C32.5772 7.886 32.2172 9.08 32.2172 10.592C32.2172 12.08 32.5772 13.268 33.2972 14.156C34.0652 15.068 35.1272 15.524 36.4832 15.524C37.8512 15.524 38.9072 15.08 39.6512 14.192C40.3832 13.316 40.7492 12.116 40.7492 10.592C40.7492 9.068 40.3832 7.856 39.6512 6.956C38.9192 6.068 37.8632 5.624 36.4832 5.624ZM49.217 3.896C50.729 3.896 51.899 4.214 52.727 4.85C53.627 5.51 54.137 6.542 54.257 7.946H52.313C52.133 7.094 51.797 6.494 51.305 6.146C50.813 5.774 50.081 5.588 49.109 5.588C48.269 5.588 47.621 5.714 47.165 5.966C46.613 6.254 46.337 6.722 46.337 7.37C46.337 7.946 46.655 8.402 47.291 8.738C47.603 8.918 48.347 9.182 49.523 9.53C51.299 10.082 52.421 10.502 52.889 10.79C53.993 11.462 54.545 12.386 54.545 13.562C54.545 14.702 54.095 15.608 53.195 16.28C52.295 16.928 51.035 17.252 49.415 17.252C47.867 17.252 46.643 16.94 45.743 16.316C44.687 15.56 44.105 14.372 43.997 12.752H45.941C46.085 13.772 46.445 14.498 47.021 14.93C47.549 15.326 48.347 15.524 49.415 15.524C50.363 15.524 51.137 15.356 51.737 15.02C52.313 14.696 52.601 14.246 52.601 13.67C52.601 12.962 52.193 12.398 51.377 11.978C51.077 11.834 50.225 11.546 48.821 11.114C47.213 10.598 46.229 10.244 45.869 10.052C44.885 9.464 44.393 8.606 44.393 7.478C44.393 6.35 44.867 5.462 45.815 4.814C46.715 4.202 47.849 3.896 49.217 3.896Z"
                    fill="#EF4F55"
                  />
                  <path
                    d="M12.5064 9.59832C12.5064 11.173 13.5332 12.5978 15 13.1977C14.7066 14.0975 14.2666 14.9974 13.7532 15.7472C13.0198 16.872 12.213 17.9219 10.9662 17.9219C9.71934 17.9968 9.27929 17.247 7.88578 17.247C6.49227 17.247 6.05221 17.9219 4.87873 17.9968C3.70525 18.0718 2.7518 16.7971 1.94503 15.7472C0.331499 13.4976 -0.841981 9.44834 0.771554 6.67383C1.57832 5.32407 3.04517 4.42422 4.58536 4.42422C5.75884 4.42422 6.93233 5.17409 7.59241 5.17409C8.25249 5.17409 9.71934 4.19926 11.1862 4.34924C12.5064 4.42422 13.7532 5.02412 14.5599 6.14892C13.3131 6.8238 12.5797 8.17357 12.5064 9.59832V9.59832ZM7.51906 4.12428C7.44572 3.07446 7.81243 2.09963 8.47252 1.34976C9.20594 0.599895 10.1594 0.0749868 11.1862 0C11.2595 1.04982 10.8928 2.09963 10.2327 2.8495C9.57266 3.74934 8.54586 4.19926 7.51906 4.12428Z"
                    fill="#EF4F55"
                  />
                </svg>
              </span>
            </ui_btn_3>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ui_btn_3 from "../ui/ui_btn_3.vue";
import common from "../../utils/common";
import axios from "axios";
export default defineComponent({
  name: "app_download",
  props: {},
  components: { ui_btn_3 },
  setup(props, ctx) {
    let router = useRouter();
    let store = useStore();
    var lang = computed(() => {
      return store.state.lang;
    });
    var langTxt = store.state.text;

    let appDownloadUr = ref();
    // const iosAppLoadUrl = 'https://redflame.ajvrdau.com/nh2c6';
    let iosAppLoadUrl = ref("");
    /* 
        下载的type类型定义：
1 IM Win
2 IM Mac
3 Game Android
4 Game IOS
5 VPN Android
6 VPN IOS
7 VPN Win
8 VPN Mac
        */

    const getIosDownloadUrl = () => {
      const sendUrl =
        common.userApi.requestUrl +
        "/misc_api/app_download_url?type=4&domain=" +
        location.hostname.replace("www.", "");
      axios
        .get(sendUrl)
        .then((r) => {
          console.log("--lb getIosDownloadUrl", r.data.url);
          if (r.data && r.data.url) {
            iosAppLoadUrl.value = r.data.url;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally();
    };
    const getDownloadUrl = () => {
      // const sendUrl = 'https://cdn.blockwar.io/apk/version.json';
      const sendUrl =
        common.userApi.requestUrl +
        "/misc_api/app_download_url?type=3&domain=" +
        location.hostname.replace("www.", "");
      axios
        .get(sendUrl)
        .then((r) => {
          console.log("--lb getDownloadUrl", r.data.url);
          if (r.data && r.data.url) {
            appDownloadUr.value = r.data.url;
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally();
    };
    const downloadApk = () => {
      window.open(appDownloadUr.value);
    };

    // 上报xbd
    const reportRefereeUser = () => {
      common.reportRefereeUser();
    };

    onMounted(() => {
      getIosDownloadUrl();
      getDownloadUrl();
    });

    return {
      langTxt,
      lang,
      downloadApk,
      appDownloadUr,
      iosAppLoadUrl,
      reportRefereeUser,
    };
  },
});
</script>

<style lang="scss" scoped>
.layout {
  background-color: #343264;
  height: 0.9rem;
  color: #9998b1;
  box-sizing: border-box;

  .box {
    height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .left {
      width: 1rem;
    }

    .right {
      .white {
        margin-left: 0.4rem;
      }

      .btn3 {
      }

      .android,
      .ios {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .android {
        svg {
          width: 0.95rem;
          height: auto;
        }
      }

      .ios {
        svg {
          width: 0.56rem;
          height: auto;
        }
      }
    }
  }
  &.onlypc {
    background: #1b203f;
    border-radius: 5px;
    width: 5.06rem;
    height: 0.59rem;
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0.28rem;
    .box {
      width: 100%;
      justify-content: space-around;
      .left {
        width: auto;
        font-size: 0.16rem;
        color: rgba(255, 255, 255, 0.5);
      }
      .right {
        display: flex;
        .btn {
          width: 1.4rem;
          height: 0.32rem;
          cursor: pointer;
          margin: 0 0.08rem;
          &:hover {
            background: linear-gradient(83.73deg, #ff8688 0%, #e9373e 99.75%);
            svg {
              rect {
                stroke: #e9373e;
              }
            }
          }
          svg {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
